export default "__VITE_ASSET__EMk4Xdns__"